import { UsersApi, AgenciesApi } from "@socotec.io/user-management-sdk";
import { userManagementConfig, fetchAll } from "@/setup/restUserManagementClient";

const usersApi = new UsersApi(userManagementConfig);
const agenciesApi = new AgenciesApi(userManagementConfig);

export const retrieveByUuid = async (uuid, failIfNoFound = true) => {
  try {
    return await usersApi.retrieve({ uuid });
  } catch (error) {
    if (!failIfNoFound && error?.response?.status === 404) {
      return undefined;
    }
    throw error;
  }
};

export const fetchUsers = async (uuids) => {
  const isInUuids = (uuids || []).filter(Boolean);
  if (!isInUuids.length) return [];
  // L.B 29/07/26 page_size par défaut de user-management = 20 : sans pagination
  // complète, au-delà de 20 uuids la liste est tronquée en silence.
  const { results } = await fetchAll(usersApi, "list", { isInUuids }, Infinity);
  return results || [];
};

export const listUser = async (params = {}) => {
  return await usersApi.list(params);
};

export const listAgencyCode = async () => {
  const { results } = await fetchAll(agenciesApi, "list", {}, Infinity);
  return results;
};
